<template>
  <div class="main">
    <div class="content-box">
      <div class="box-title">土地扭转面积分布</div>
      <div class="map"></div>
    </div>
    <div class="content-box2">
      <div class="box-title">区域土地流转面积增长率分析
        <div class="title-right">
          <el-radio-group v-model="tabPosition" @change="change">
            <el-radio-button v-for="item,index in initRadios" :label="item" :key="index">{{item}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="rightechart">
        <div class="body-title" v-show="isShow"><span class="title-name">{{bodyTitle}}:</span>
          <el-select v-model="value" placeholder="请选择" @change="selectChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <component :is="userAsset" :data="echartData"></component>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" scoped>
  import areadistrict from '../../components/echarts/areadistrict.vue'
  import areatime from '../../components/echarts/areatime.vue'
  import {echartsMixin} from '../../assets/js/common/mixin'

  export default {
    data() {
      return {
        userAsset: 'areadistrict',
        tabPosition: '区域',
        initRadios: ['区域', '时间'],
        bodyTitle: '请选择',
        options: [{
          index: 0,
          value: '默认'
        }, {
          index: 1,
          value: '高>低'
        }, {
          index: 2,
          value: '低>高'
        }],
        isShow: true,
        value: '',
        echartData: {}
      }
    },
    methods: {
      change(val) {
        if (val == "区域") {
          this.userAsset = "areadistrict";
        }
        else {
          this.userAsset = "areatime";
        }
      },
      selectChange(val) {
        console.log(val)
      },
      _resizeHanlder() {
        console.log(1);
      }
    },
    components: {
      areadistrict,
      areatime
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  .main {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-box {
      width: calc((100% - 20px) / 2);
      height: 100%;
      background-color: #002624;
      border: solid 1px rgba(0, 255, 238, 0.5);
      box-sizing: border-box;
      .box-title {
        height: 30px;
        padding-left: 12px;
        line-height: 30px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
      }
      .map {
        width: 100%;
        height: calc(100% - 30px);
        background: url('../../../static/img/areaspread.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .content-box2 {
      width: calc((100% - 20px) / 2);
      height: 100%;
      background-color: #002624;
      border: solid 1px rgba(0, 255, 238, 0.5);
      box-sizing: border-box;
      .box-title {
        height: 30px;
        padding-left: 12px;
        line-height: 30px;
        background-image: linear-gradient(79deg, rgba(0, 255, 238, 0.5) 0%, rgba(0, 243, 247, 0.4) 25%, rgba(0, 230, 255, 0.3) 50%, rgba(0, 230, 255, 0.1) 100%);
        background-blend-mode: normal, normal;
        .title-right {
          display: inline-block;
          float: right;
          margin-right: 12px;
          line-height: 30px;
          // margin-top: -4px;
        }
        .title-right /deep/ .el-radio-group {
          background-color: #071210;
          border-radius: 11px;
          border: solid 1px rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button__inner {
          height: 20px;
          padding: 4px 20px;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          background: #002624;
          border-color: rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
          background: #009288;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          color: #a4cabd;
        }

        .title-right /deep/ .el-radio-button.is-active .el-radio-button__inner {
          color: #ffffff;
        }

        .title-right /deep/ .el-radio-button:focus {
          box-shadow: 0 0 1px 1px rgba(0, 248, 153, 0.3);
        }

        .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:first-child:focus {
          border-top-left-radius: 11px;
          border-bottom-left-radius: 11px;
        }

        .title-right /deep/ .el-radio-button:first-child .el-radio-button__inner {
          border-left: none;
        }

        .title-right /deep/ .el-radio-button .el-radio-button__inner {
          line-height: 11px;
        }

        .title-right /deep/ .el-radio-button:last-child .el-radio-button__inner, .title-right /deep/ .el-radio-button:last-child:focus {
          border-top-right-radius: 11px;
          border-bottom-right-radius: 11px;
        }
      }

      .rightechart {
        position: relative;
        top: 0;
        width: 99%;
        height: 403px;
        .body-title {
          margin: 12px 14px;
        }

        .body-title /deep/ .el-input__inner {
          width: 92px;
          height: 22px;
          background-color: #002623;
          border-radius: 11px;
          border: solid 1px rgba(0, 248, 153, 0.3);
          color: #d9eee7;
          font-size: 12px;
        }

        .body-title .title-name {
          margin-left: 0;
          font-size: 12px;
          color: #bffffb;
        }
      }
    }
  }
</style>









// WEBPACK FOOTER //
// src/pages/transaction/area.vue